<template>
  <section class="section container">
    <div class="mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("tailoring order module settings") }}
      </h1>
    </div>

    <div class="box mt-0">
      <div class="columns">
        <div class="column is-5">
          <h1 class="title is-4">{{ $t("ordering links") }}</h1>
        </div>
        <div class="column is-7">
          <p class="buttons is-pulled-right">
            <button class="button is-secondary is-rounded" @click="create">
              <span class="icon"><i class="fa fa-plus"></i></span>
              <span>{{ $t("add") }}</span>
            </button>
            <!-- <button
              class="button is-primary is-rounded"
              @click="refresh"
              :disabled="is_loading"
              v-bind:class="{ 'is-loading': is_loading }"
              :data-tooltip="$t('refresh')"
            >
              <span class="icon">
                <i class="fa fa-refresh"></i>
              </span>
              <span>{{ $t("refresh") }}</span>
            </button> -->
          </p>
        </div>
      </div>
      <div class="table-container" ref="tc">
        <table
          class="table is-striped is-hoverable"
          ref="table"
          style="width: 100%"
        >
          <thead>
            <tr>
              <th>{{ $t("establishment") }}</th>
              <th>{{ $t("link") }}</th>
              <!-- <th>{{ $t("setup") }}</th> -->
              <th>{{ $t("options") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(ordering_link, pidx) in meta.ordering_links"
              :key="pidx"
            >
              <td>
                <span
                  class="icon has-text-success"
                  v-if="ordering_link.is_enabled"
                >
                  <i class="fa fa-check"></i>
                </span>
                <span class="icon has-text-danger" v-else>
                  <i class="fa fa-remove"></i>
                </span>
                {{ ordering_link.establishment }}
              </td>
              <td>
                <a
                  :href="`${current_host}/tailoring_order/order/${ordering_link.url_name}`"
                  >{{
                    `${current_host}/tailoring_order/order/${ordering_link.url_name}`
                  }}</a
                >
              </td>
              <td>
                <p class="buttons">
                  <a
                    class="button"
                    :data-tooltip="$t('configure')"
                    @click="configure_ordering_link(ordering_link)"
                  >
                    <span class="icon has-text-info">
                      <i class="fa fa-cogs"></i>
                    </span>
                  </a>
                  <a
                    class="button"
                    :data-tooltip="$t('delete')"
                    @click="meta.ordering_links.splice(pidx, 1)"
                  >
                    <span class="icon has-text-danger">
                      <i class="fa fa-trash"></i>
                    </span>
                  </a>
                </p>
              </td>
            </tr>
          </tbody>
          <tfoot></tfoot>
        </table>
      </div>
    </div>

    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
    <!-- <ordering-link-modal
      ref="ordering_link_modal"
      @success="ordering_link_modified"
    /> -->
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  success_message,
  error_message,
  current_host,
} from "@/utils";
import { isEmpty } from "lodash";
import { v4 } from "uuid";
// import OrderingLinkModal from "./ordering_link_modal/Index.vue";

export default {
  name: "TailoringOrderSettings",
  components: {
    /* OrderingLinkModal */
  },
  data() {
    return {
      meta: { ordering_links: [] },
      current_host,
    };
  },
  methods: {
    save() {
      let v = this;
      let data = { ...v.meta };
      v.$root.loader(true);
      save_configuration(v, data)
        .then(() => {
          success_message(v.$t("configuration saved"));
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    create() {
      let v = this;
      v.meta.ordering_links.push({
        uuid: v4(),
        establishment: v.$t("new ordering link"),
      });
    },
    configure_ordering_link(ordering_link) {
      let v = this;
      v.$refs.ordering_link_modal.show_modal(ordering_link);
    },
    ordering_link_modified(ordering_link) {
      let v = this;
      let trgt = v.meta.ordering_links.find(
        (p) => p.uuid === ordering_link.uuid
      );
      if (trgt) {
        Object.keys(ordering_link).map((k) => {
          trgt[k] = ordering_link[k];
        });
      }
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf && !isEmpty(conf)) {
          if (conf.ordering_links) {
            conf.ordering_links = conf.ordering_links.map((p) => {
              p.products = p.products || [];
              return p;
            });
          }
          v.meta = conf;
        }
      })
      .catch((error) => {
        error_message(error);
      })
      .finally(() => {
        v.$root.loader(false);
      });
  },
};
</script>

<style></style>
